import React from "react";
import { Box, IconButton, Typography, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

interface MissingLocationStatusModalProps {
  open: boolean;
  onClose: () => void;
  systemRemarks: string;
}

const MissingLocationStatusModal: React.FC<MissingLocationStatusModalProps> = ({
  open,
  onClose,
  systemRemarks,
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "330px",
        padding: "20px",
        backgroundColor: "#e3f2fd",
        borderRadius: "12px",
        boxShadow: 1,
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "#555",
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "#f57c00", marginBottom: "10px" }}
      >
        Warning
      </Typography>
      <Divider sx={{ width: "100%", marginBottom: "10px" }} />

      <Box sx={{ width: "100%" }}>
        {(systemRemarks?.split(/,\s*/) || [])
          .map((remark, index) => remark.trim())
          .filter((remark) => remark.length > 0)
          .map((remark, index) => (
            <Box
              display="flex"
              alignItems="flex-start"
              mb={1}
              key={`remark-${index}`}
            >
              <InfoIcon
                sx={{ color: "#1976d2", mr: 1, mt: "2px" }}
                fontSize="small"
              />
              <Typography
                variant="body2"
                sx={{ color: "#333", fontSize: "1rem", lineHeight: "1.5" }}
              >
                {remark}
              </Typography>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default MissingLocationStatusModal;
